import { mainPageContainerSx } from 'components/styles/container';
import { Container } from 'components/ui';

const MainContainer = ({ children }) => {
  return (
    <Container sx={mainPageContainerSx} maxWidth="xl">
      {children}
    </Container>
  );
};

export default MainContainer;
